"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
const mystake_auth_frontend_sdk_1 = require("@boulevard1/mystake-auth-frontend-sdk");
/* eslint-disable @typescript-eslint/no-explicit-any */
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("./constants");
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["get"] = "GET";
    HttpMethod["post"] = "POST";
    HttpMethod["patch"] = "PATCH";
    HttpMethod["put"] = "PUT";
    HttpMethod["delete"] = "DELETE";
})(HttpMethod || (HttpMethod = {}));
/** a configured axios instance that can be used to interact with api */
class HttpService {
    constructor(firebaseAuthConfig) {
        this.baseUrl = 
        // eslint-disable-next-line no-nested-ternary
        process.env.REACT_APP_LOCALHOST === "true"
            ? constants_1.LOCALHOST_URL
            : process.env.REACT_APP_API_BASE_URL
                ? process.env.REACT_APP_API_BASE_URL
                : constants_1.SERVER_URL;
        this.axiosInstance = axios_1.default.create({
            baseURL: this.baseUrl,
            validateStatus: (status) => status >= 200 && status < 500,
        });
        this.firebaseInstance = mystake_auth_frontend_sdk_1.FirebaseAuthService.getInstance(firebaseAuthConfig);
    }
    static getInstance() {
        var _a;
        if (!HttpService.instance) {
            const firebaseAuthConfig = ((_a = window === null || window === void 0 ? void 0 : window.config) === null || _a === void 0 ? void 0 : _a.FIREBASE_AUTH_CONFIG) || {};
            HttpService.instance = new HttpService(firebaseAuthConfig);
        }
        return HttpService.instance;
    }
    get(url, data, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosHttpFunction(url, HttpMethod.get, data, headers);
            return response;
        });
    }
    post(url, data, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosHttpFunction(url, HttpMethod.post, data, headers);
            return response;
        });
    }
    patch(url, data, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosHttpFunction(url, HttpMethod.patch, data, headers);
            return response;
        });
    }
    put(url, data, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosHttpFunction(url, HttpMethod.put, data, headers);
            return response;
        });
    }
    delete(url, data, headers) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosHttpFunction(url, HttpMethod.delete, data, headers);
            return response;
        });
    }
    axiosHttpFunction(url, method, data, customHeaders) {
        return __awaiter(this, void 0, void 0, function* () {
            const authToken = yield this.firebaseInstance.getIdToken();
            const headers = Object.assign({ authorization: `Bearer ${authToken}`, "session-id": (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("sessionId")) || "" }, customHeaders);
            try {
                const response = yield this.axiosInstance({
                    url,
                    method,
                    data,
                    headers,
                });
                return response;
            }
            catch (error) {
                if (error.response) {
                    if ((error === null || error === void 0 ? void 0 : error.response.status) === 401) {
                        yield this.firebaseInstance.signOut();
                        window.location.href = `${process.env.REACT_APP_WEB_BASE_URL}/signin`;
                    }
                }
                return error;
            }
        });
    }
}
exports.HttpService = HttpService;
//# sourceMappingURL=HttpService.js.map